import type {
  Alert,
  Phone,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { InfoButton } from "@tandemdiabetes/sugarmate-react-components"
import { useMemo } from "react"

import { ContactCard } from "./ContactCard"
import styles from "./Contacts.module.scss"
import { usePolyglot } from "src/contexts"
import { usePhones } from "src/hooks"

const polyglotPrefix = "pages.alerts.contacts."

interface Props {
  sugarmateAlert: Alert;
  primaryPhone: Phone | undefined;
}

export function Contacts(props: Props) {
  const {
    sugarmateAlert,
    primaryPhone,
  } = props

  const polyglot = usePolyglot()
  const { data: phones } = usePhones()

  const existingContacts = useMemo(
    () => phones?.filter(
      (phone) => sugarmateAlert.phone_ids.includes(phone.id) && !phone.is_primary && phone.deleted_at === null,
    ),
    [
      phones,
      sugarmateAlert,
    ],
  )

  if (!existingContacts?.length) {
    return null
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.heading}>
          {polyglot.t(`${polyglotPrefix}existing_contacts_heading`)}
          <InfoButton title={polyglot.t(`${polyglotPrefix}existing_contacts_info.title`)}>
            <div>
              {polyglot.t(`${polyglotPrefix}existing_contacts_info.description_one`)}
            </div>
            <div>
              {polyglot.t(
                `${polyglotPrefix}existing_contacts_info.description_two`,
                {
                  dataSharing: (
                    <strong className={styles.semibold}>
                      {polyglot.t(`${polyglotPrefix}existing_contacts_info.data_sharing`)}
                    </strong>
                  ),
                },
              )}
            </div>
          </InfoButton>
        </div>
        {existingContacts.map((phone) => (
          <ContactCard
            key={phone.id}
            sugarmateAlert={sugarmateAlert}
            phone={phone}
            primaryPhone={primaryPhone}
          />
        ))}
      </div>
    </>
  )
}
